// import vue
import Vue from 'vue'

// import vuetify
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

// import all icons
import 'vue-awesome/icons'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

// Import the Icon component
import Icon from 'vue-awesome/components/Icon.vue'

Vue.component('icon', Icon)
Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md'
  }
})
